"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCourierWebhookEventData = instanceOfCourierWebhookEventData;
exports.CourierWebhookEventDataFromJSON = CourierWebhookEventDataFromJSON;
exports.CourierWebhookEventDataFromJSONTyped = CourierWebhookEventDataFromJSONTyped;
exports.CourierWebhookEventDataToJSON = CourierWebhookEventDataToJSON;
exports.CourierWebhookEventDataToJSONTyped = CourierWebhookEventDataToJSONTyped;
/**
 * Check if a given object implements the CourierWebhookEventData interface.
 */
function instanceOfCourierWebhookEventData(value) {
    return true;
}
function CourierWebhookEventDataFromJSON(json) {
    return CourierWebhookEventDataFromJSONTyped(json, false);
}
function CourierWebhookEventDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'status': json['status'] == null ? undefined : json['status'],
        'opened': json['opened'] == null ? undefined : json['opened'],
        'recipientId': json['recipientId'] == null ? undefined : json['recipientId'],
    };
}
function CourierWebhookEventDataToJSON(json) {
    return CourierWebhookEventDataToJSONTyped(json, false);
}
function CourierWebhookEventDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'status': value['status'],
        'opened': value['opened'],
        'recipientId': value['recipientId'],
    };
}
//# sourceMappingURL=CourierWebhookEventData.js.map